
import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import MusicPlayer from '@/components/MusicPlayer';
import { useIsMobile } from '@/hooks/use-mobile';

const Music = () => {
  const isMobile = useIsMobile();

  useEffect(() => {
    console.log('Music page loaded');

    // Additional logging to help diagnose routing issues
    console.log('Current pathname:', window.location.pathname);
    console.log('Current URL:', window.location.href);
  }, []);

  return (
    <main className="min-h-screen bg-gradient-to-b from-white to-honey-50 pt-24">
      <div className="container mx-auto px-4 py-8 md:py-12">
        <nav className="text-sm text-gray-500 mb-4">
          <Link to="/" className="hover:underline">Главная</Link> {' > '} <span className="font-semibold">Музыка</span>
        </nav>

        <div className="text-center mb-8 md:mb-12 pt-8">
          <h1 className="font-cormorant-garamond text-4xl md:text-5xl font-bold">МУЗЫКА</h1>
        </div>

        <div className="max-w-2xl mx-auto">
          <p className="text-center text-gray-700 mb-8 md:mb-10">
            Насладитесь спокойной музыкой, которая отлично сочетается с ароматом наших свечей, создавая атмосферу уюта и гармонии.
          </p>

          <div className="flex justify-center mb-12 md:mb-16">
            <MusicPlayer />
          </div>

          <div className="mt-12 md:mt-16 bg-honey-50 p-6 md:p-8 rounded-lg shadow-md border border-honey-100">
            <h2 className="font-cormorant-garamond text-xl md:text-2xl font-semibold mb-4 text-center">Почему музыка и ароматы?</h2>
            <p className="text-gray-700 mb-4">
              Сочетание приятной музыки и натуральных ароматов пчелиного воска создает особую атмосферу, которая помогает расслабиться и отдохнуть от повседневных забот.
            </p>
            <p className="text-gray-700">
              Включите нашу музыку, зажгите свечу BUDNIK Bee Garden, и позвольте себе раствориться в моменте спокойствия и гармонии.
            </p>
          </div>
        </div>
      </div>
    </main>
  );
};

export default Music;
